import { FunctionComponent } from 'react';
import { TextStyle } from '@shopify/polaris';
import styled from 'styled-components';
import { FallbackProps } from 'react-error-boundary';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

const ErrorHeading = styled.h1`
  margin: 2rem 0;
  font-weight: bold;
  font-size: 2.5rem;
`;

const ErrorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;

  span {
    text-align: center;
  }
`;

const ErrorMessage = styled.div`
  font-size: 1.5rem;
  margin-bottom: 1.25rem;
`;

const Message: FunctionComponent<FallbackProps> = ({ error }) => {
  return (
    <Container>
      <ErrorHeading>Oops! Something went wrong</ErrorHeading>
      <ErrorMessageContainer>
        <ErrorMessage>
          Try refreshing your page. If this issue persists, contact
          support@givz.com
        </ErrorMessage>

        <TextStyle>Full error: {error.message}</TextStyle>
      </ErrorMessageContainer>
    </Container>
  );
};

export default Message;
